import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const EmtpyGroupComponent = () => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:px-4")}>
            <div className={cn("tw:bg-grey tw:py-1 tw:px-2")}>
                {t("general.miniCart.empty.title")}
            </div>
            <p className={cn("tw:text-sm tw:font-normal tw:py-2")}>
                {t("general.miniCart.empty.message")}
            </p>
            <div className={cn("tw:text-center")}>
                <i
                    className={cn(
                        "las la-cart-plus",
                        "tw:text-grey-light tw:text-7xl"
                    )}
                />
            </div>
        </div>
    );
};
